import fetch from 'utils/fetch';

export function rechargeLogList( startTime,endTime,accountBegin,accountEnd,agent,productId,type,status,psize,currentPage,remark) {
    const data = {
        startTime,
        endTime,
        accountBegin,
        accountEnd,
        productId,
        agent,
        type,
        remark,
        status,
        psize,
        currentPage
    };
    return fetch({
        url: '/rechargeLogList',
        method: 'get',
        params : data
    });
}
export function getAgentInfo(account) {
    const data = {
        account
    };
    return fetch({
        url: '/getAgentInfo',
        method: 'get',
        params : data
    });
}



// WEBPACK FOOTER //
// ./src/api/rechargeLog.js